import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface FeedLeague {
  externalId: string;
  sportId: string;
  name: string;
  code: string;
  season?: string;
}

interface FeedLeaguesResponse {
  leagues: FeedLeague[];
}

export type { FeedLeague };

export const getFeedLeagues = async (sportId?: string): Promise<FeedLeague[]> => {
  const response = (await api.get('/feed/leagues', {
    params: sportId ? { sportId } : {},
  })) as FeedLeaguesResponse;
  return response.leagues || [];
};

export const useGetFeedLeaguesQuery = (sportId?: string, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: queryKeys.feed.leagues(sportId || 'all'),
    queryFn: () => getFeedLeagues(sportId),
    staleTime: 5 * 60 * 1000, // 5 minutes - leagues don't change often
    enabled: options?.enabled !== false,
  });
};
